// extracted by mini-css-extract-plugin
module.exports = {"min":"0","mini":"375px","xs":"480px","sm":"576px","md":"768px","lg":"992px","xl":"1200px","xsl":"1400px","xxl":"1600px","hd":"1920px"};